import { GetKeyMeasurementsResponse } from "../../../../../../../server/types/request/report/key-mesurements";
import type { AdCopyKeyMeasurementsLatestAction } from "../../../../../types/actions";
import type { MessageInfo } from "../../../../../types/info";

type State = {
	data: GetKeyMeasurementsResponse["data"];
	info: MessageInfo;
	job?: GetKeyMeasurementsResponse["job"];
	loading: boolean;
};

export const initState: State = {
	data: [],
	info: {
		isSuccess: true,
		message: "",
	},
	loading: true,
};

export const reducer = (state: State, action: AdCopyKeyMeasurementsLatestAction): State => {
	switch (action.type) {
		case "loadData":
			return {
				...state,
				loading: false,
				...action.payload,
			};

		case "changeMessageInfo":
			return {
				...state,
				info: action.payload,
				loading: false,
			};

		case "changeLoading":
			return {
				...state,
				loading: action.payload,
			};
	}
};
